module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "artist"
  }, [_c('h2', {
    staticClass: "name"
  }, [_c('a', {
    attrs: {
      "href": _vm.artist.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.name))])]), _c('img', {
    attrs: {
      "src": _vm.artist.image[2]['#text']
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e766e5e2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/artist.vue
// module id = 18
// module chunks = 0